import { oz } from '@weft/utils';
import { ApiDateSchema,
  ObjectIdSchema, PaymentInfoSchema,
  PaymentTermSchema,
  SYNC_STATUSES,
  SyncStatusSchema,
  TaxRateSchema } from '../../primitives';
import { InvoiceBillingStatusSchema } from '../../primitives/invoice-billing-status-schema';
import { InvoiceReviewStatusSchema } from '../../primitives/invoice-review-status-schema';
import { PeriodSchema } from '../../primitives/period-schema';
import { withNullAsOptional } from '../../utils';
import { NewLineItemSchema } from '../line-item';
import { TrialDurationSchema } from '../plan';
import { RevenueBreakdownSchema } from '../revenue-breakdown';
import { RevisionedLineItemSchema } from '../revisioned-line-item/revisioned-line-item-schema';

export const NewInvoiceSchema = oz.object({
  name: oz.string().nonempty(),
  reviewStatus: InvoiceReviewStatusSchema,
  billingStatus: InvoiceBillingStatusSchema,
  billingCycle: PeriodSchema,
  customerId: ObjectIdSchema,
  taxRate: TaxRateSchema,
  issuedAt: ApiDateSchema,
  dueDate: ApiDateSchema,
  lineItems: oz.array(NewLineItemSchema),
  revisionedLineItems: oz.array(RevisionedLineItemSchema),
  contractId: ObjectIdSchema.optional(),
  paymentTerm: PaymentTermSchema,
  revenueBreakdown: RevenueBreakdownSchema,
  approvedAt: ApiDateSchema.optional(),
  paymentDueDays: oz.number(),
  trial: withNullAsOptional(TrialDurationSchema),
  syncStatus: SyncStatusSchema.default(SYNC_STATUSES.None),
  syncStatusUpdatedAt: withNullAsOptional(ApiDateSchema),
  paymentInfo: PaymentInfoSchema.optional(),
}).openapi('NewInvoice');

export type NewInvoice = oz.infer<typeof NewInvoiceSchema>;